var map = {
	"./account-ico-mail.svg": 812,
	"./account-ico-pass.svg": 813,
	"./account-ico-phone.svg": 814,
	"./bank-transfer.svg": 815,
	"./betnearn-ico.svg": 816,
	"./birthday-bonus-ico.svg": 817,
	"./birthday.webp": 1915,
	"./bonus-code-ico.svg": 818,
	"./bonus-ico.svg": 819,
	"./bonus-received-ico.svg": 820,
	"./bonus.webp": 1916,
	"./business-account-upgrade-ico.svg": 821,
	"./check-in-daily-ico.svg": 822,
	"./checked.svg": 823,
	"./cloud-pointer.svg": 824,
	"./crypto.svg": 825,
	"./daily-bonus-ico.svg": 826,
	"./daily-limit.webp": 1917,
	"./deposit-delay-bonus-ico.svg": 827,
	"./e-wallet.svg": 828,
	"./earn-coin-ico.svg": 829,
	"./earn-x33-coin-ico.svg": 830,
	"./email.svg": 831,
	"./facebook.svg": 832,
	"./feedback.svg": 833,
	"./first-bet-ico.svg": 834,
	"./games-rebate-ico.svg": 835,
	"./info.svg": 836,
	"./instagram.svg": 837,
	"./instant-rebate.svg": 838,
	"./live-casino-rebate-ico.svg": 839,
	"./lucky-spin-ico.svg": 840,
	"./messenger.svg": 841,
	"./mobile-app-deposit-ico.svg": 842,
	"./monthly-cash.webp": 1918,
	"./msg-activity.svg": 843,
	"./msg-ann.svg": 844,
	"./msg-notice.svg": 845,
	"./new-icon.svg": 846,
	"./people-ico.svg": 847,
	"./quick-pay.svg": 848,
	"./r77-coin.svg": 849,
	"./rescue-bonus-ico.svg": 850,
	"./rescue-lc-ico.svg": 851,
	"./rescue-slots-ico.svg": 852,
	"./return.svg": 853,
	"./sc-bc-active-ico.svg": 854,
	"./sc-bc-ico.svg": 855,
	"./sc-bi-active-ico.svg": 856,
	"./sc-bi-ico.svg": 857,
	"./sc-mail-active-ico.svg": 858,
	"./sc-mail-ico.svg": 859,
	"./sc-mp-active-ico.svg": 860,
	"./sc-mp-ico.svg": 861,
	"./sc-pin-active-ico.svg": 862,
	"./sc-pin-ico.svg": 863,
	"./slots-rebate-ico.svg": 864,
	"./sports-rebate-ico.svg": 865,
	"./telegram.svg": 866,
	"./twitter.svg": 867,
	"./vip-up-level-ico.svg": 868,
	"./vip-weekly-bonus.svg": 869,
	"./wallet-ico.svg": 870,
	"./weekly-tournament-ico.svg": 871,
	"./welcome-bonus-ico.svg": 872,
	"./whatsapp.svg": 873,
	"./withdrawal-delay-bonus-ico.svg": 874,
	"./withdrawal.webp": 1919,
	"./x33-coin.svg": 875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 476;